import React from 'react'
import Wave from 'react-wavify'
import coreservice1 from '../../Image/coreservice1.png';
import coreservice2 from '../../Image/coreservice2.png';
import coreservice3 from '../../Image/coreservice3.png';
import coreservice4 from '../../Image/coreservice4.png';
import coreservice5 from '../../Image/coreservice5.png';
import { useNavigate } from 'react-router-dom';

const CoreService = () => {
    const coreService = [
        { Image: coreservice1, title: 'Mobile App Development', description: 'We try to create team of developers for software development project on a short-term, long-term, or permanent basis with guaranteed project delivery at affordable prices.',href:'/service/mobile'},
        { Image: coreservice2, title: 'Web Development', description: 'Our web developer can make client base websites and web apllication solutions. We Drop-ship Websites that can help you for the growth of your business using internet technology.', href:'/service/web'},
        { Image: coreservice3, title: 'UI/UX Design', description: 'UI design focuses on the visual elements and interactive components of a product, including layout, colors, typography, icons, buttons, and other graphical elements.',href:'/service/design' },
        { Image: coreservice4, title: 'Hire Directed Devleoper', description: 'We try to create team of developers for software development project on a short-term, long-term, or permanent basis with guaranteed project delivery at affordable prices.',href:'/'},
        { Image: coreservice5, title: '24/7 Support', description: 'We provide the best services, ensuring immediate support interruption for any of your technical issues or challenges, our team is always available to assist you.',href:'/contact' },
    ]
    const navigate = useNavigate()
    return (
        <div className='overflow-hidden '>
            <Wave fill='#F6F6F6' paused={false} style={{ display: 'flex' }} options={{ height: 20, amplitude: 20, speed: 0.3, points: 5 }} className='relative min-w-[1920px] h-[28px] bg_theme-light' />
            <div className=' bg-[#f6f6f6] py-5'>
                <div className='container py-8'>
                    <div className='text-center  m-auto '>
                        <div className='flex justify-center flex-wrap'>
                            <h1 className='uppercase text-2xl  sm:text-3xl 2xl:text-[40px] font-bold text-[#141414]  leading-[40px] 2xl:leading-[66px]'>OUR</h1>
                            <h1 className='uppercase text-2xl  sm:text-3xl 2xl:text-[40px] font-bold text-theme_dark  leading-[40px] 2xl:leading-[66px] ps-2'> CORE</h1>
                            <h1 className='uppercase text-2xl  sm:text-3xl 2xl:text-[40px] font-bold  leading-[40px] 2xl:leading-[66px] ps-2'> SERVICES</h1>
                        </div>
                    </div>
                </div>
                <div className='container flex justify-center flex-wrap'>
                    {coreService?.map((item, ind) => {
                        return (
                            <div className='2xl:w-1/3 lg:w-1/2 2xl:py-8 2xl:px-[60px] sm:p-8 py-5  relative sp_card_main' data-aos="fade-up" data-aos-duration="1000">
                                <div>
                                    <div className='sp_cardbox1'></div>
                                    <div className='sp_cardbox2'></div>
                                </div>
                                <div className='xl:p-5 p-3 text-center sp_corecard h-full'>
                                    <div className='flex justify-center items-center'>
                                        <img src={item.Image} alt='core service icon'></img>
                                    </div>
                                    <div className='font-semibold  text-xl  sm:text-xl 2xl:text-xl  text-[#141414]  lg:mb-[10px] w-[60%] m-auto py-3'>
                                        <h5 className='text-[#141414]'>{item.title}</h5>
                                    </div>
                                    <p className='xl:text-[16px] font-medium  pt-0 pb-5 lg:px-8 py-0 text-[#000000B2]'>{item.description}</p>
                                    <div className='sp_coreicon' onClick={()=>{navigate(item.href)}}>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M18.711 -0.000976562H3.59772C2.88678 -0.000976562 2.30865 0.577148 2.30865 1.28809C2.30865 1.99902 2.88678 2.57715 3.59772 2.57715H15.5938L0.378967 17.7959C-0.124939 18.2998 -0.124939 19.1162 0.378967 19.6201C0.882873 20.124 1.69928 20.124 2.20319 19.6201L17.418 4.40137V16.3975C17.418 17.1084 17.9962 17.6865 18.7071 17.6865C19.418 17.6865 19.9962 17.1084 19.9962 16.3975V1.28809C20.0001 0.577148 19.4219 -0.000976562 18.711 -0.000976562Z" fill="#8A49D6" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        )
                    })}

                </div>
            </div>
            
        </div>
    )
}

export default CoreService
